export default Object.freeze({
	Sku: 'Sku',
	Name: 'Name',
	QtyAsc: 'QtyAsc',
	QtyDesc: 'QtyDesc',
});
